export default "__VITE_PUBLIC_ASSET__456f3c96__"